import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-[10px] border text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border-black bg-black text-white hover:bg-neutral-800",
        outline: "border-neutral-200 bg-white text-ink hover:bg-neutral-50",
        ghost: "border-transparent bg-transparent text-neutral-600 hover:bg-neutral-100 hover:text-ink",
        lemon: "border-lemon bg-lemon text-black hover:brightness-95",
        danger: "border-red-600 bg-red-600 text-white hover:bg-red-700",
      },
      size: {
        default: "h-[38px] px-4",
        sm: "h-8 rounded-lg px-3 text-[13px]",
        lg: "h-11 px-5 text-[15px]",
        icon: "h-9 w-9 p-0",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export const Button = forwardRef(function Button({ className, variant, size, asChild = false, ...props }, ref) {
  const Comp = asChild ? Slot : "button";
  return <Comp ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
});
